<template>
  <Modal ref="modal" title="Mapa da aula" @cancel="close">
    <template v-if="loading">
      <div class="loading">
        <i class="fa fa-spinner fa-spin"></i>
        <span>Carregando...</span>
      </div>
    </template>
    <div v-else-if="anotacao" class="map-container">
      <GoogleMap
        v-if="anotacao.posicoes.length"
        :infractions="anotacao.infracoes"
        :positions="anotacao.posicoes"
        :beginTime="aula.data_aula"
      />
      <div class="empty" v-else>
        <span>Sem coordenadas da aula</span>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import GoogleMap from '../google/GoogleMap'

export default {
  name: 'MapModal',
  components: {
    Modal,
    GoogleMap
  },
  data() {
    return {
      aula: null,
      anotacao: null,
      loading: false
    }
  },
  methods: {
    async details(aulaId) {
      this.loading = true
      try {
        const { body } = await this.$http.get(`${process.env.VUE_APP_URL_API}/aulas/praticas/realizada/${aulaId}`)
        this.aula = body.dados
        this.anotacao = body.dados.anotacao
      } catch (err) {
        console.error(err)
        this.$refs.modal.close()
        this.$toasted.show('Erro ao buscar informações da aula.', {
          icon: 'fa-times',
          position: 'top-right',
          duration: 5000,
          fullWidth: false,
        })
      } finally {
        this.loading = false
      }
    },
    async open(id) {
      await this.details(id)

      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
      this.aula = null
      this.anotacao = null
    }
  }
}
</script>

<style lang="scss" scoped>
.empty, .loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: var(--text-secondary);
}

.loading {
  flex-direction: column;
  gap: 1rem;
  
  i {
    font-size: 2rem;
  }
}

.map-container {
  width: 60vw;
}
</style>